module.exports = __webpack_public_path__ + "img/DEBI-Platinum.8c508a24.png";